import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      {/* Left Side - Image */}
      <div className="w-full lg:w-1/2 relative h-72 md:h-96 lg:h-[520px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20of%20a%20spotlight%20illuminating%20an%20empty%20stage%20with%20a%20single%20microphone%20stand%2C%20red%20velvet%20curtains%20in%20background%2C%20warm%20golden%20and%20deep%20crimson%20lighting%2C%20mysterious%20and%20inviting%20atmosphere%2C%20theater%20stage%20aesthetic%2C%20editorial%20photography%2C%20high%20contrast%2C%20professional%20quality%2C%20dramatic%20shadows%2C%20elegant%20composition&width=960&height=700&seq=gossip-cta-left&orientation=landscape"
          alt="爆料大赛"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
        <div className="absolute bottom-8 left-8 z-10">
          <span className="text-white/60 text-xs md:text-sm">全民参与</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white mt-1">爆料大赛</h2>
        </div>
      </div>

      {/* Right Side - Content */}
      <div className="w-full lg:w-1/2 bg-background-50 flex items-center justify-center px-4 py-12 md:py-16 lg:py-0">
        <div className="max-w-md text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-600 text-xs font-semibold mb-4">
            🏆 月度爆料王
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
            你有猛料
            <br />
            我们<span className="text-primary-500">有舞台</span>
          </h2>
          <p className="text-foreground-500 text-sm leading-relaxed mb-8">
            不管是明星八卦、网红翻车还是行业黑幕，只要料够猛、够真实，
            就来吃瓜网爆料！每月评选"爆料王"，赢取丰厚奖金和全网曝光！
          </p>

          {/* Prize Info */}
          <div className="flex items-center justify-center gap-6 md:gap-10 mb-8">
            <div className="text-center">
              <p className="text-primary-500 font-heading text-2xl md:text-3xl font-bold">¥10,000</p>
              <p className="text-foreground-400 text-xs mt-1">月度冠军</p>
            </div>
            <div className="w-px h-10 bg-secondary-300"></div>
            <div className="text-center">
              <p className="text-accent-500 font-heading text-2xl md:text-3xl font-bold">¥3,000</p>
              <p className="text-foreground-400 text-xs mt-1">亚军奖励</p>
            </div>
            <div className="w-px h-10 bg-secondary-300"></div>
            <div className="text-center">
              <p className="text-secondary-500 font-heading text-2xl md:text-3xl font-bold">¥1,000</p>
              <p className="text-foreground-400 text-xs mt-1">季军奖励</p>
            </div>
          </div>

          <Link
            to="/about"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            立即参与爆料 <i className="ri-arrow-right-up-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}